import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { CustomReportServiceBase } from './custom-report/custom-report-base.service';
import {
    BoxResultType,
    BuildingClient,
    CustomReportBuildingView,
    EntityTypeCustomFieldDto,
    GetBuildingColumnChartValuesResultType,
    GetBuildingLineChartValuesResultType,
    GetBuildingMetricsValuesResultType,
    GetBuildingValuesParameters,
    GetBuildingValuesResultType,
    ReportResultColumnDto,
    SharedReportDto
} from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class ReportingBuildingService extends CustomReportServiceBase<BuildingClient, CustomReportBuildingView> {
    constructor(protected override client: BuildingClient) {
        super(client);
    }

    async getBuildingBoxesValues(parameters: GetBuildingValuesParameters): Promise<BoxResultType[]> {
        return await lastValueFrom(this.client.buildingGetBuildingBoxesValues(parameters));
    }

    async getBuildingColumnChartValues(
        parameters: GetBuildingValuesParameters
    ): Promise<GetBuildingColumnChartValuesResultType[]> {
        return await lastValueFrom(this.client.buildingGetBuildingColumnChartValues(parameters));
    }

    async getBuildingLineChartValues(
        parameters: GetBuildingValuesParameters
    ): Promise<GetBuildingLineChartValuesResultType[]> {
        return await lastValueFrom(this.client.buildingGetBuildingLineChartValues(parameters));
    }

    async getBuildingMetricsValues(
        parameters: GetBuildingValuesParameters
    ): Promise<GetBuildingMetricsValuesResultType> {
        return await lastValueFrom(this.client.buildingGetBuildingMetricsValues(parameters));
    }

    async getBuildingValues(parameters: GetBuildingValuesParameters): Promise<GetBuildingValuesResultType[]> {
        return await lastValueFrom(this.client.buildingGetBuildingValues(parameters));
    }
    override async saveCustomReport(body: CustomReportBuildingView): Promise<CustomReportBuildingView> {
        if (body.isPublic) return await lastValueFrom(this.client.buildingSaveCatalogReport(body));
        else return await lastValueFrom(this.client.buildingSaveCustomReport(body));
    }

    override async getCustomReport(id: number): Promise<CustomReportBuildingView> {
        return await lastValueFrom(this.client.buildingGetCustomReport(id));
    }

    override async shareReport(body: CustomReportBuildingView): Promise<SharedReportDto> {
        return await lastValueFrom(this.client.buildingCreateSharedReport(body));
    }

    override async getSharedReport(id: string): Promise<CustomReportBuildingView> {
        return await lastValueFrom(this.client.buildingGetSharedReport(id));
    }

    async getCustomFieldColumns(organizationIds: number[]): Promise<EntityTypeCustomFieldDto[]> {
        return await lastValueFrom(this.client.buildingGetCustomFieldColumns(organizationIds));
    }

    override async getResultAvailableColumns(organizationIds: number[]): Promise<ReportResultColumnDto[]> {
        return await lastValueFrom(this.client.buildingResultAvailableColumns(organizationIds));
    }
}
